export default __webpack_public_path__ + "static/media/team3-1.531d7bd6.png";